module.exports = __webpack_public_path__ + "img/madeira.8a6d24cb.svg";